import { PsHttpService, type PatSnapCommonResponseData, } from '@patsnap/tahiti-core/common/ps-http';
import { injectable, } from '@patsnap/tahiti-core/shared/inversify';
import { coreSearchApiUrlPrefix, } from 'library-@/config/constants';
import type {
    ApiSearchSettingLanguageRequest, ApiTranslateSpecificFieldRequest,SearchSettingLanguage,
    ApiSearchSettingLanguageResponse, ApiTranslateSpecificFieldResponse, TranslateSpecificField,
    ApiFetchCompareInitRequest, ApiFetchCompareInitResponse,FetchCompareInit,
    ApiGetCompareListRequest, ApiGetCompareListResponse, GetCompareList,
    ApiGetCompareOverviewRequest, ApiGetCompareOverviewResponse, GetCompareOverview,
    ApiGetCompareTextRequest, ApiGetCompareTextResponse, GetCompareText,
    ApiSearchComparePatentRequest, ApiSearchComparePatentResponse, SearchComparePatent,
    ApiAddComparePatentRequest, ApiAddComparePatentResponse, AddComparePatent,
    ApiGetComparePatentTextRequest, ApiGetComparePatentTextResponse, GetComparePatentText,
} from './core-search-api-service.interface';
import { SearchSocketJob, type ApiSearchSocketJobRequest, type ApiSearchSocketJobResponse } from '@analytics/shared/apis/core-search-api-service.interface';

@injectable()
export class CoreSearchApiServiceImpl extends PsHttpService
    implements
        TranslateSpecificField,
        SearchSettingLanguage,
        FetchCompareInit,
        GetCompareList,
        GetCompareOverview,
        GetCompareText,
        SearchComparePatent,
        AddComparePatent,
        SearchSocketJob,
        GetComparePatentText
{

    get options() {
        return {
            baseURL: coreSearchApiUrlPrefix,
            headers: {
                'X-API-Version': '2.0',
            },
        };
    }

    async translateSpecificField(data: ApiTranslateSpecificFieldRequest): Promise<ApiTranslateSpecificFieldResponse> {
        const res = await this.post<PatSnapCommonResponseData<ApiTranslateSpecificFieldResponse>>({
            url: '/translate/specific-field',
            data,
            transformCode: true,
        });
        return res.data;
    }

    async getSelectedLanguage(params: ApiSearchSettingLanguageRequest): Promise<ApiSearchSettingLanguageResponse> {
        const res = await this.get<PatSnapCommonResponseData<ApiSearchSettingLanguageResponse>>({
            url: '/search-setting/language',
            params,
            transformCode: true,
        });
        return res.data;
    }

    async fetchCompareInit(data: ApiFetchCompareInitRequest) {
        const res = await this.post<PatSnapCommonResponseData<ApiFetchCompareInitResponse>>({
            url: '/view/compare/v2/compare-init',
            data,
            transformCode: true,
        });
        return res.data;
    }

    async getCompareList(params: ApiGetCompareListRequest) {
        const res = await this.get<PatSnapCommonResponseData<ApiGetCompareListResponse>>({
            url: '/view/compare/v2/compare-list',
            params,
            transformCode: true,
        });
        return res.data;
    }

    getCompareOverviewChannel = Symbol('getCompareOverviewChannel');
    async getCompareOverview(data: ApiGetCompareOverviewRequest) {
        const res = await this.channel<PatSnapCommonResponseData<ApiGetCompareOverviewResponse>>(
            this.getCompareOverviewChannel,
            {
                url: '/view/compare/v2/compare-overview',
                method: 'POST',
                data,
                transformCode: true,
            }
        );
        return res.data;
    }

    async getCompareText(data: ApiGetCompareTextRequest) {
        const res = await this.post<PatSnapCommonResponseData<ApiGetCompareTextResponse>>({
            url: '/view/compare/v2/compare-text',
            data,
            transformCode: true,
        });
        return res.data;
    }

    async searchComparePatent(data: ApiSearchComparePatentRequest) {
        const res = await this.post<PatSnapCommonResponseData<ApiSearchComparePatentResponse>>({
            url: '/view/compare/v2/compare-search',
            data,
            transformCode: true,
        });
        return res.data;
    }

    async addComparePatent(data: ApiAddComparePatentRequest) {
        const res = await this.post<PatSnapCommonResponseData<ApiAddComparePatentResponse>>({
            url: '/view/compare/v2/compare-add',
            data,
            transformCode: true,
        });
        return res.data;
    }

    async getComparePatentText(data: ApiGetComparePatentTextRequest) {
        const res = await this.post<PatSnapCommonResponseData<ApiGetComparePatentTextResponse>>({
            url: '/view/compare/v2/compare-patent',
            data,
            transformCode: true,
            uuid: `compare-patent__${data.compare_id}_${data.patent_id}_${data.lang}_${data.field_type}`,
        });
        return res.data;
    }

    async searchSocketJob(data: ApiSearchSocketJobRequest): Promise<ApiSearchSocketJobResponse> {
        const res = await this.post<PatSnapCommonResponseData<ApiSearchSocketJobResponse>>({
            url: '/copilot/job',
            data,
            transformCode: true,
        });
        return res.data;
    }
}
